import { Directive } from "@angular/core";

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: "g-avatar-prefix",
})
export class AvatarPrefixDirective {
  constructor() {}
}
